import { createReducer, on } from '@ngrx/store';
import { setIsuredMattersValues } from './insuredMattersValues.actions';

export const initialIsuredMattersValuesState = {
  predioValue: 0,
  conteudoValue: 0,
  lucroValue: 0,
  predioConteudo: 0,
  source: '',
};

export const isuredMattersValuesReducer = createReducer(
  initialIsuredMattersValuesState,
  on(
    setIsuredMattersValues,
    (state, { predioValue, conteudoValue, lucroValue, predioConteudo, source }) => ({
      ...state,
      predioValue,
      conteudoValue,
      lucroValue,
      predioConteudo,
      source,
    })
  )
);
